/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portals_WebsiteInputs */

const cs_portals_website = /** @type {(inputs: Portals_WebsiteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Web`)
};

const en_portals_website = /** @type {(inputs: Portals_WebsiteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Website`)
};

/**
* | output |
* | --- |
* | "Website" |
*
* @param {Portals_WebsiteInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const portals_website = /** @type {((inputs?: Portals_WebsiteInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portals_WebsiteInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_portals_website(inputs)
	return cs_portals_website(inputs)
});